import { Intervention } from '@/app/components/action-plan/types';
import { TypeOfCancer } from '../icons/icon-catch/types';

const NOT_APPLICABLE = 'N/A';

export function useActionPlanSummaryController() {
  const getBadgeValue = (intervention: Intervention, cancerId: TypeOfCancer): string => {
    if (intervention.isNonQuantifiable) return NOT_APPLICABLE;

    const matchingRiskImpact = intervention.riskImpact.find((riskImpact) => riskImpact.cancerType === cancerId);

    if (!matchingRiskImpact?.impact) return NOT_APPLICABLE;

    return matchingRiskImpact.impact.toString();
  };

  return {
    getBadgeValue,
  };
}
